import { useScopedAppFlagStore } from '@frontend/scope';
import { featureFlags } from '../../../feature-flags';
import { useIsMulti } from '../../../hooks/use-is-multi';

export const useHasAutoRecallAnalyticsFeature = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isAutoRecallAnalyticsDisabled = getFeatureFlagValue(featureFlags.disableAutoRecallInAnalytics);
  const { isMulti } = useIsMulti();

  if (isMulti) {
    // Auto recall analytics is not supported for multi-locations
    return false;
  }

  return !isAutoRecallAnalyticsDisabled;
};
